import { FC, useMemo, useState } from "react";
import BusForm from "./BusForm";
import PayloadForm from "./PayloadForm";
import "./Console.scss";
// import CustomRadioButton from "../../../../custom_components/CustomRadioButton";
import RawForm from "./RawForm";
import CustomTcForm from "./CustomTcForm";
import CustomSelect from "../../../../../CommonComponents/CustomSelect";
import useScenario from "../../../../hooks/useScenario";

interface TelecommandSectionProps {
  communication_type: string;
  command_type: any;
  set_command_type: (type: any) => void;
  busComponentOptions: any[];
  fetchBusCommands: (components: string) => void;
  busCommandOptions: any[];
  allPayloadComponents: any[];
  formContainerHeight: number;
}

const TTCFormSection: FC<TelecommandSectionProps> = ({
  communication_type,
  command_type,
  set_command_type,
  busComponentOptions,
  fetchBusCommands,
  busCommandOptions,
  allPayloadComponents,
  formContainerHeight,
}) => {
  const { scenario } = useScenario();
  const scenarioDeploymentType = useMemo(() => scenario?.scenarioDeploymentType, [scenario?.scenarioDeploymentType]);
  const showPayloadCommand = useMemo(() => scenarioDeploymentType === 'HARDWARE_IN_LOOP' || scenarioDeploymentType === 'QUICK_DEPLOY', [scenarioDeploymentType]);
  const commandType = [
    { label: "Bus Command", value: "Bus" },
    ...(showPayloadCommand ? [{ label: "Payload Command", value: "Payload" }] : []),
    { label: "Raw", value: "Raw" },
    { label: "Custom Tc", value: "Custom Tc" }
  ];

  const handleCommandTypeChange = (data) => {
    sessionStorage.setItem("selectedCommandType", JSON.stringify(data));
    set_command_type(data);
  }

  return (
    <div
      className={"left__panel__body__form__section__container modal__scrollbar__white"}
      style={{
        maxHeight: `calc(100vh - ${255 + formContainerHeight}px)`,
      }}
    >
      <div className="left__panel__body__input__dropdown__container left__panel__body__input__custom__dropdown left__panel__body_input__border">
        <span>Type</span>
        <CustomSelect
          options={commandType}
          value={command_type}
          placeholder="Select type"
          onChange={(data) => { handleCommandTypeChange(data) }}
          background="rgba(10,10,10,0.65)"
          isSearchable={false}
        />
      </div>
      {command_type?.value === "Bus" && <BusForm busComponentOptions={busComponentOptions} fetchBusCommands={fetchBusCommands} busCommandOptions={busCommandOptions} />}
      {command_type?.value === "Payload" && <PayloadForm allPayloadComponents={allPayloadComponents} />}
      {command_type?.value === "Raw" && <RawForm />}
      {(command_type?.value === "Custom Tc" || command_type?.value === "CustomTc") && <CustomTcForm />}
    </div>
  );
};

export default TTCFormSection;
